<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="profile-alocacao-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span> 
                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-4" v-if="opcoes">
                                <label for="opcaoAlocacao" class="form-label">Opção</label>
                                <Multiselect id="opcaoAlocacao" v-model="opcao_id" :options="opcoes_select" :searchable="true" @change="refreshTable" />
                            </div>
                           
                            <div class="col-12 col-md-6 col-lg-8 panel-actions" > 
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                                <button type="button" class="btn btn-sm btn-pmes-primary" title="Inserir nova opcao de Lotacao" data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro_locacao_alocacao" >
                                    <span class="menu-icon">
                                        <i class="fa fa-plus fa-2x bi"></i>
                                    </span>
                                    Inserir
                                </button> 
                            </div>
                            
                        </div>

                        <Cadastro :service="service" :modal="modal_cadastro_locacao_alocacao" :perfis="perfis" @locacao-alterado="refreshTable" />
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false" @tableatualizada="tableatualizada($event)">
                            <th>Id</th>
                            <th>Unidade</th>
                            <th>Opcao</th>
                            <th style="min-width:130px" class="text-center">Acoes</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import { namespace } from "vuex-class";
    import $ from "jquery";
    import CardRh from "@/components/cards/ManzaCard.vue";
    import AlocacaoService from "@/service/v10/sigap/AlocacaoService";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import Multiselect from "@vueform/multiselect";
    import Cadastro from "./_Cadastro.vue";

    const authStore = namespace("auth");

    @Options({
        name: "OpcaoIndex",
        components: { CardRh, KDataTable, Multiselect, Cadastro },
    })
    export default class OpcaoIndex extends Vue {
        @authStore.Getter
        public perfis!: any;

        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public opcao_id: any = null;
        public matriculaId: any = null;
        public opcoes: any = null;
        public modal_cadastro_locacao_alocacao = "modal_turma_locacao_alocacao";

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === "Enter" || e.keyCode === 13) {
                this.refreshTable();
            }
        }

        public limparFiltros() {
            this.opcao_id = null;
            this.refreshTable();
        }

        get opcoes_select() {
            if (this.opcoes) {
                return this.opcoes.map((item) => {
                    return { value: item.id, label: item.nome };
                });
            }
            return [];
        }

        public getOpcao() {
            this.processando = true;
            this.service.getOpcao()
                .then(response => {
                    this.opcoes = JSON.parse(JSON.stringify(response));
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }

        created() {
            this.matriculaId = this.$route.params.id;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new AlocacaoService();
            this.getOpcao();
            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        opcao: this.opcao_id,
                        matriculaId: this.matriculaId,
                        search: d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: "id", name: "id" },
                { data: "unidade.descricao", name: "unidade.descricao" },
                { data: "opcao", name: "opcao", class: "desktop" },
                { data: "id", name: "id", class: "desktop" },
            ];

            this.config.columnDefs = [
                {
                    targets: 2,
                    render: (row) => {
                        return row.nome.replaceAll("_", " ");
                    }
                },
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + ' title="Excluir"><i class="fa fa-trash"></i></button>';
                        return texto;
                    },
                }
            ];
        }

        public tableatualizada() {
            $("[btn-excluir]").click((btn) => {
                const id = $(btn.currentTarget).data("id");
                this.excluirModelo(id);
            });
        }

        protected excluirModelo(id) {
            SiteUtils.alertConfimacao("Confirma a Exclusao", "",
                () => {
                    this.processando = true;
                    setTimeout(() => {
                        this.service.excluir(id)
                            .then(() => {
                                this.reloadDatatable = !this.reloadDatatable;
                                SiteUtils.toastSucesso("Exclusao realizada com sucesso!!");
                                this.processando = false;
                            })
                            .catch(error => {
                                this.processando = false;
                                SiteUtils.toastErro("Nao foi possivel Excluir", error.data.message);
                            });
                    }, 10);
                }
            );
        }
    }
</script>

<style scoped>
    .profile-alocacao-page {
        display: grid;
        gap: 24px;
    }

    .filter-panel,
    .table-panel {
        border: 1px solid #e5edf6;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
        padding: 15px;
    }

    .filter-panel {
        position: relative;
        padding-top: 24px;
    }

    .panel-border-label {
        position: absolute;
        top: -9px;
        left: 18px;
        padding: 0 10px;
        background: #ffffff;
        color: #102542;
        font-size: 0.95rem;
        font-weight: 800;
        line-height: 1.4;
    }

    .table-panel {
        padding: 2px 10px !important;
    }

    .panel-heading {
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        gap: 10px;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e9eef5;
    }

    .panel-actions {
        text-align: end; 
        margin-top: 20px;
    }

    .btn-sm {
        margin-left: 10px;
    }

     

    @media screen and (max-width: 991px) {
        .filter-panel,
        .table-panel {
            padding: 18px;
            border-radius: 18px;
        }

        .filter-panel {
            padding-top: 26px;
        }

        .panel-heading {
            flex-direction: column;
            align-items: stretch;
        }
    }
</style>
